import { parseSearchResults } from "./parser"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

const initialState = {
    error: null,
    searchTerm: "",
    isFetched: false,
    isFetching: false,
    searchResults: {},
    searchSuggestions: {},
    searchResponseType: null,
}

export const searchSlice = createSlice({
    name: "search",
    initialState: initialState,
    reducers: {
        resetSearchResults: (state) => {
            state.isFetched = false
            state.isFetching = false
            state.searchResults = {}
            state.searchSuggestions = {}
            state.searchResponseType = {}
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSearchData.fulfilled, (state, action) => {
            const { searchResults, searchSuggestions, searchResponseType } = parseSearchResults(
                action.payload
            )
            state.error = null
            state.isFetched = true
            state.isFetching = false
            state.searchResults = searchResults
            state.searchSuggestions = searchSuggestions
            state.searchResponseType = searchResponseType
        }),
            builder.addCase(fetchSearchData.pending, (state) => {
                state.isFetched = false
                state.isFetching = true
            }),
            builder.addCase(fetchSearchData.rejected, (state, action) => {
                state.error = action.payload
            })
    },
})

export const fetchSearchData = createAsyncThunk("search/fetchSearchData", async (payload, { extra }) => {
    const { api } = extra
    const res = await api.get("/api/v4/search/autocomplete", { params: payload })
    return res.data
})

export const { resetSearchResults, setSearchTerm } = searchSlice.actions

export const searchReducer = searchSlice.reducer
